import React, { useEffect } from 'react';
import { useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  ListItemButton,
  ListItemText,
  Stack,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { useGetUsersQuery } from '../slices/usersApiSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import ListContainer from '../components/ListContainer';
import ScreenContainer from '../components/ScreenContainer';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function UsersScreen() {
  const { state } = useLocation();
  const { data: users, refetch, isLoading, isError } = useGetUsersQuery();

  const navigate = useNavigate();
  const [hideHeader, setHideHeader] = useState(true);
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    if (state?.refetch) {
      refetch();
    }
  }, [state, refetch]);

  useEffect(() => {
    console.log('UsersScreen users', users);
    if (users?.filters) {
      setFilters(users.filters);
    }
  }, [users]);

  const goBack = () => {
    navigate('/projects/v2/');
  };

  const goTo = (id) => {
    navigate(`/users/${id}`);
  };

  const handleCreate = () => {
    navigate(`/register`);
  };

  if (isLoading) {
    return <CircularProgress />;
  } else if (isError) {
    return (
      <Alert severity='warning'>
        {isError?.data?.message || isError.error}
      </Alert>
    );
  }

  const buttons = [
    {
      title: 'Создать новый этап',
      onClick: handleCreate,
      type: 'icon',
      icon: <AddIcon />,
      xs: 2,
      position: 'left',
    },
    {
      title: 'Закрыть',
      onClick: () => {
        navigate(-1);
      },
      type: 'icon',
      icon: <CloseIcon />,
      xs: 2,
      position: 'right',
    },
  ];

  const Subheader = ({ filters }) => {
    return (
      <Stack
        direction={'column'}
        spacing={0}
        alignItems={'flex-start'}
        onClick={() => setHideHeader(!hideHeader)}
      ></Stack>
    );
  };

  return (
    <ScreenContainer buttons={buttons}>
      <Card>
        <CardHeader
          title={'Сотрудники'}
          subheader={<>{hideHeader ? <Subheader filters={filters} /> : ''}</>}
          action={
            <>
              {filters && Array.isArray(filters) && filters.length > 0 && (
                <IconButton onClick={() => setHideHeader(!hideHeader)}>
                  {hideHeader ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
              )}
            </>
          }
        ></CardHeader>
        <CardContent sx={{ pt: 0 }}>
          {users &&
            users.map((user, index) => (
              <span key={user._id}>
                <Grid container spacing={0} alignItems='center'>
                  <Grid item xs={12}>
                    <ListItemButton
                      onClick={() => goTo(user._id)}
                      sx={{ pl: 0 }}
                    >
                      <ListItemText primary={<strong>{user.name}</strong>} />
                    </ListItemButton>
                  </Grid>
                </Grid>
                <Divider />
              </span>
            ))}
        </CardContent>
      </Card>
    </ScreenContainer>
  );
}
